import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 1rem;

    > h2 {
        margin-top: 2rem;
        font-size: 1.25rem;
        font-weight: 700;
        line-height: 1.5rem;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
        h2 {
            margin-top: 4rem;
            font-size: 1.5rem;
            line-height: 2rem;
        }
    }
`

export const CollapseContainer = styled.div`
    padding: 0;
    margin-bottom: 2rem;

    svg {
        height: 0.75rem;
    }

    h3 {
        max-width: 17.25rem;
        font-weight: 500;
        font-size: 1rem;
        line-height: 1.5rem;
    }

    > div {
        > div {
            font-weight: 600;
            font-size: 1rem;
            line-height: 1.5rem;

            > div {
                font-weight: 400;
                font-size: 0.875rem;

                span {
                    height: 100%;
                    color: #363636;
                    font-weight: 400;
                    font-size: 0.875rem;
                    line-height: 1.5rem;
                    max-width: 18.5rem;
                }
            }
        }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
        flex-direction: column;
        display: flex;
        margin: 0 auto 1.5rem;
        max-width: 36.75rem;
        padding: 0;

        h3 {
            max-width: 32.75rem;
            font-weight: 700;
        }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
        max-width: 54.5rem;
    }
`

export const ButtonBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 26rem;
    gap: 1.5rem;
    margin-bottom: 4.5rem;

    button {
        height: 3rem;
        width: 100%;
        border-radius: 8px;
    }

    a {
        flex: 1;
        display: flex;
        justify-content: center;
    }

    @media (max-width: 28.5rem) {
        width: 100%;
        flex-direction: column;

        a {
            width: 100%;
        }
    }
`
